import React, { Fragment } from "react";
import Card from "../components/Card";
import useVehiclesList from "../components/fetchVehicles";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import generateCarUrl from "../modules/generateCarUrl";
import useWindowSize from "../components/useWindowSize";

function CarListPage() {
    const [listVehicles, isLoading, isError] = useVehiclesList();
    const {width} = useWindowSize();

    return (
        <Fragment>
            <Breadcrumb className="breadcrumb_overrides">
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/lista-carros-usados-stand-pombal" active>
                    Lista de Veiculos
                </Breadcrumb.Item>
            </Breadcrumb>
            <section className="my-3">
                <div className="container text-center">
                    <h3 className="d-inline-block px-3 title_lista_veiculos font-weight-bold">
                        Listagem de Veículos
                    </h3>
                    <div className="separator d-block" />
                </div>
                {isError && <div>Ocorreu um erro ...</div>}
                {isLoading ? (
                    <div 
                        className="d-flex justify-content-center loadingContainer"
                        style={{ height: width > 768 ? "2800px":"1800px" }}
                    >
                        <div className="sk-chase">
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                        </div>
                    </div>
                ) : (
                    <div className="row justify-content-center mx-3">
                        {listVehicles.map(vehicle => {
                            const {
                                list_images,
                                name,
                                id,
                                make,
                                model,
                                gear_type,
                                registration_year,
                                registration_month,
                                price,
                                mileage,
                                fuel,
                                power
                            } = vehicle;

                            return (
                                <div
                                    className="col-sm-6 my-2 col-lg-3"
                                    key={id}
                                >
                                    <Card
                                        img={list_images[0]}
                                        name={name}
                                        make={make}
                                        model={model}
                                        gear_type={gear_type}
                                        registration_year={registration_year}
                                        registration_month={registration_month}
                                        mileage={mileage}
                                        price={price}
                                        fuel={fuel}
                                        id={id}
                                        power={power}
                                        carUrl={
                                            generateCarUrl({
                                                id,
                                                make,
                                                model,
                                                price,
                                                registration_year,
                                                registration_month,
                                            })
                                        }
                                    />
                                </div>
                            );
                        })}
                    </div>
                )}
            </section>
        </Fragment>
    );
}
export default CarListPage;
